function ChartModule(){
    return(
        <button type="button" className="btn">
            <span className="btn__text">Create Chart</span>
        </button>
    )
}

export default ChartModule